/**
   * Group array by key
   * @param {Array} list 
   * @param {String} key 
   */
const groupArrayBy = (list, key) => {
    return list.reduce(
        (result, item) => ({
            ...result,
            [item[key]]: [
                ...(result[item[key]] || []),
                item,
            ],
        }),
        {},
    );
}

/**
 * Get key in array
 * @param {*} object 
 * @param {string} value 
 */
const getKeyByValue = (object, value) => {
    return Object.keys(object).find(key => object[key] === value);
}

/**
 * Check if array is empty
 * @param {array} array 
 * @returns 
 */
const isEmptyArray = (array) => {
    return !array || array.length === 0
}

/**
 * Troca os index to array
 * 
 * @param {Array} arr 
 * @param {Number} index1 
 * @param {Number} index2 
 */
export const swapArray = function (arr, index1, index2) {
    [arr[index1], arr[index2]] = [arr[index2], arr[index1]]
}

export { groupArrayBy, getKeyByValue, isEmptyArray };
